export default {
  namespaced: true,
  state: {
    // 用户信息
    info: {},
    // 用户是否开通了短信服务
    smsServiceStatus: undefined,
    matchStatus: {}
  },
  getters: {
    shedInfo(state) {
      return state.info.shed || {}
    },
    userInfo(state) {
      return state.info.user || {}
    },
    permission(state) {
      return state.info.permissions || ''
    },
    // 用户是否开通了短信服务
    getSmsServiceStatus(state) {
      return state.smsServiceStatus
    },
    //当前赛事
    getMatchStatus(state) {
      return state.matchStatus
    }
  },
  actions: {
    /**
     * @description 设置用户数据
     * @param {Object} state vuex state
     * @param {*} info info
     */
    set({ state, dispatch }, info) {
      return new Promise(async resolve => {
        // store 赋值
        state.info = info


        // 持久化
        await dispatch(
          'd2admin/db/set',
          {
            dbName: 'sys',
            path: 'user.info',
            value: info,
            user: true
          },
          { root: true }
        )
        // end
        resolve()
      })
    },
    /**
     * @description 从数据库取用户数据
     * @param {Object} state vuex state
     */
    load({ state, dispatch }) {
      return new Promise(async resolve => {
        // store 赋值
        state.info = await dispatch(
          'd2admin/db/get',
          {
            dbName: 'sys',
            path: 'user.info',
            defaultValue: {},
            user: true
          },
          { root: true }
        )
        state.smsServiceStatus = await dispatch(
          'd2admin/db/get',
          {
            dbName: 'sys',
            path: 'user.smsServiceStatus',
            defaultValue: undefined,
            user: true
          },
          { root: true }
        )
        state.matchStatus = await dispatch(
          'd2admin/db/get',
          {
            dbName: 'sys',
            path: 'user.matchStatus',
            defaultValue: {},
            user: true
          },
          { root: true }
        )
        // end
        resolve()
      })
    },
    /**
     * @description 设置用户是否开通短信服务
     * @param {Object} state vuex state
     */
    setSmsServiceStatus({ state, dispatch }, status) {
      return new Promise(async resolve => {
        // store 赋值
        state.smsServiceStatus = status
        // 持久化
        await dispatch(
          'd2admin/db/set',
          {
            dbName: 'sys',
            path: 'user.smsServiceStatus',
            value: status,
            user: true
          },
          { root: true }
        )
        // end
        resolve()
      })
    },
    /**
     * @description 存当前选中赛事
     * @param {Object} state vuex state
     */
    setMatchStatus({ state, dispatch }, status) {
      console.log('status', status)
      return new Promise(async resolve => {
        // store 赋值
        state.matchStatus = status
        // 持久化
        await dispatch(
          'd2admin/db/set',
          {
            dbName: 'sys',
            path: 'user.matchStatus',
            value: status,
            user: true
          },
          { root: true }
        )
        // end
        resolve()
      })
    },
  }
}
